/**
 * @module UseRegisterFields
 * @description Phase 16 extraction of a shared react-hook-form v6 field-registration hook.
 * RHF note: under shouldUnregister:true, fields must be registered here or they drop from handleSubmit data.
 */

import { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';

/**
 * Register form fields on mount for react-hook-form v6.
 * Under shouldUnregister:true, fields must be explicitly registered
 * or they are silently dropped from handleSubmit() data.
 *
 * @param {string[]} fieldNames Array of field name paths to register.
 */
export function useRegisterFields(fieldNames) {
    const { register } = useFormContext();
    const registeredSignatureRef = useRef('');

    useEffect(() => {
        const fieldNamesSignature = fieldNames.join('|');

        if (registeredSignatureRef.current === fieldNamesSignature) {
            return;
        }

        registeredSignatureRef.current = fieldNamesSignature;
        fieldNames.forEach((name) => register({ name }));
    }, [fieldNames, register]);
}
